module.exports = __webpack_public_path__ + "img/gsxw_1.6ef0ada4.png";